<template>
    <div id="contactus">
        <b-button v-b-modal.modal-tall squared variant="dark">{{ $t('contact-us.button') }}</b-button>

        <b-modal id="modal-tall" title="Contact" cancel-disabled>
            <div class="d-flex justify-content-between">
                <h5><i class="fa fa-phone fa-1x mx-1" style="color: black"></i>{{ $t('contact-us.phone') }}</h5>
                <b-button variant="dark" squared href="tel:+1418-626-8359"> Call Us</b-button>
            </div>
            <div>
                <h5 class="font-weight-light">(418) 626-8359</h5>
            </div>
            <br>

            <div class="d-flex justify-content-between">
                <h5><i class="fa fa-map-marker fa-1x mx-1" style="color: black"></i>{{ $t('contact-us.address') }}
                </h5>
                <b-button variant="dark" squared href="https://maps.app.goo.gl/BomTsM7BcdkP8xz69" target="_blank">Map
                    Address</b-button>
            </div>
            <div>
                <h5 class="font-weight-light">
                    Location - (Charlesbourg)<br>
                    8335 Boulevard Henri-Bourassa<br>
                    Québec, QC G1G 4E1
                </h5>
            </div>
            <br>

            <div class="d-flex justify-content-between">
                <h5><i class="fa fa-map-marker fa-1x mx-1" style="color: black"></i>{{ $t('contact-us.address') }}
                </h5>
                <b-button variant="dark" squared href="https://maps.app.goo.gl/crFyaCsiRshKpfhWA" target="_blank">Map
                    Address</b-button>
            </div>
            <div>
                <h5 class="font-weight-light">
                    Location - (Ste-Foy)<br>
                    3100 Rue de la Forest #200<br>
                    Québec City, QC G1W 1L8
                </h5>
            </div>
            <br>

            <div class="d-flex justify-content-between">
                <h5><i class="fa fa-envelope fa-1x mx-1" style="color: black"></i>{{ $t('contact-us.email') }}</h5>
                <b-button variant="dark" squared href="mailto:info@beauteintegrale.ca">Email Us</b-button>
            </div>
            <div>
                <h5 class="font-weight-light">info@beauteintegrale.ca
                </h5>
            </div>
            <br>

            <div class="d-sm-flex flex-row justify-content-between">
                <h5><i class="fa fa-calendar fa-1x mx-1" style="color: black"></i>Appointments</h5>
                <appt-button v-bind:color="'d'" :block="true" v-on:close="closeModal()" />

            </div>
            <br>

            <template v-slot:modal-footer="{ close }">
                <div class="w-100">
                    <b-button variant="outline-dark" squared size="sm" class="float-right" @click="close()">
                        Close
                    </b-button>
                </div>
            </template>

        </b-modal>
    </div>
</template>
<script>
import { store, mutations } from '@/store/store.js'

export default {
    data() {
        return {
            modal: true
        }
    },
    methods: {
        toggleModal() {
            this.modal = !this.modal
        },
        closeModal() {
            this.$root.$emit('bv::hide::modal', 'modal-tall')
        }
    },
}
</script>
<style scoped>
h3 {
    font-weight: 100;
}

.text {
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/buttons/ContactUs.vue